import Axios from 'axios';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import getMetaTagData from '../../../src/common/services/getMetaTagData';
import ServiceNotice from '../../../src/component/pc/pass/ServiceNotice';

import cookieCutter from 'cookie-cutter';
import { toStringByDateFormat } from "../../../src/common/utils/dateUtil";
import { getLnbList } from "../../../src/common/utils/passUtil";
import FoldBanner from "../../../src/component/pc/pass/FoldBanner";
import PassGroup from "../../../src/component/pc/pass/pass/PassGroup";
import PassGroupTable from "../../../src/component/pc/pass/pass/PassGroupTable";
import PassSlider from "../../../src/component/pc/pass/pass/PassSlider";
import SlideBanner from "../../../src/component/pc/pass/SlideBanner";

function Pass({ metaTagData, passData, topEventBannerData, loginJwt, platform }) {

  const [isFoldBannerOpen, setIsFoldBannerOpen] = useState(false);
  const [displayLang, setDisplayLang] = useState('ko');

  //화면시작시 최초 한번 시작...
  useEffect(async () => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const displayLang = cookieCutter.get('SBS_DL');
    setDisplayLang(displayLang)
  }, [displayLang]);

  const foldBannerOpenToggleHandler = () => {
    if (isFoldBannerOpen) {
      setIsFoldBannerOpen(false);
    } else {
      setIsFoldBannerOpen(true);
    }
  };

  return (
    <>
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_PC_PASSMONEY_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />
        <script src='//developers.kakao.com/sdk/js/kakao.min.js' />
        <meta name='description' content={metaTagData.shareDescription} />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={metaTagData.shareTitle || ''} />
        <meta property='og:description' content={metaTagData.shareDescription || ''} />8
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={metaTagData.shareTitle || ''} />
        <meta name='nate:description' content={metaTagData.shareDescription || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div id="container" className="contents">
        <div className="passmoneyContents">{/* 페이지 명 클래스  */}
          {/* lnb list */}
          {getLnbList('pc')}
          <div className="passmoneyCont_pass area01">
            {/* 스와이퍼 배너영역 */}
            {/*topEventBannerData && (<SlideBanner data={topEventBannerData} />)*/}
            {/* 배너 : 확장성 배너 */}
            {/* open-banner 추가시 하단 내용 보임. */}
            {/*passData.pass_event_banner && (<div className={`foldBannerWrap ${isFoldBannerOpen ? 'open-banner' : ''}`}><FoldBanner data={passData.pass_event_banner} onClick={foldBannerOpenToggleHandler} isFoldBannerOpen={isFoldBannerOpen} /></div>)*/}
            <PassSlider />
          </div>
          <div class="passmoneyCont_pass area02">
            <div class="passVisualText_w">
              <ul class="list01">
                <li>
                  <div class="img-con01">
                    <img src="/images/pass/pass_icon01.png " class="img" alt="" />
                  </div>
                  <div class="tit-wrap">
                    <strong class="title01"><em>광고 없는</em> 실시간 라이브</strong>
                  </div>
                  <div class="txt01"><em>인기 SBS 채널을 초고화질</em>로,<br />생생하게 즐겨보세요!</div>
                </li>
                <li>
                  <div class="img-con01">
                    <img src="/images/pass/pass_icon02.png " class="img" alt="" />
                  </div>
                  <div class="tit-wrap">
                    <strong class="title01"><em>무제한</em> 다시보기</strong>
                  </div>
                  <div class="txt01"><em>10만 편 레전드 콘텐츠,</em><br />언제든지 마음껏 시청하세요!</div>
                </li>
                <li>
                  <div class="img-con01">
                    <img src="/images/pass/pass_icon03.png" class="img" alt="" />
                  </div>
                  <div class="tit-wrap">
                    <strong class="title01">실시간 라이브 <em>타임머신</em></strong>
                  </div>
                  <div class="txt01"><em>최대 2시간 전까지,</em> 놓쳐도 걱정 마세요.<br />되돌아볼 수 있어요!</div>
                </li>
              </ul>
            </div>
          </div>
          <div className="passmoneyCont_pass area03">
            {/* 이용권 리스트 */}
            {passData.pass_group && (<div className="passContents"><PassGroup data={passData.pass_group} loginJwt={loginJwt} platform={platform} displayLang={displayLang} /></div>)}
          </div>
          {/* 이용권 정보 표 */}
          <div class="passmoneyCont_pass area04">
            {passData.pass_group_table && (<div className="passInfoTable_w"><PassGroupTable data={passData.pass_group_table} /></div>)}
            {/* 서비스 이용 유의사항 */}
            {passData.service_notice && (<div className="noticeList_wrap"><ServiceNotice data={passData.service_notice} /></div>)}
          </div>
          {/*<!-- 광고 : 날개배너 -->*/}
          <div className="contents_bottom_ad">
            <div className="bottom_ad_inner">
              <iframe title='배너광고' display='block' src='/html/pc/pass.htm' width='970px' height='250px' scrolling='no' frameBorder='0' align='middle' marginWidth='0' marginHeight='0' />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const getPassData = async () => {
  let result = null;

  //console.log('NEXT_PUBLIC_API_PASS_KO :>> ', process.env.NEXT_PUBLIC_API_PASS_KO);

  try {
    const passData = await Axios.get(process.env.NEXT_PUBLIC_API_PASS_KO, { timeout: 3000 });
    result = passData.data ? { ...passData.data } : null;

    //console.log(result);

  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

const getTopEventBanner = async () => {
  let result = null;

  //console.log('NEXT_PUBLIC_API_TOP_EVENT_BANNER :>> ', process.env.NEXT_PUBLIC_API_TOP_EVENT_BANNER);

  try {
    const today = toStringByDateFormat(new Date);

    const topEventBannerData = await Axios.get(process.env.NEXT_PUBLIC_API_TOP_EVENT_BANNER, { timeout: 3000 });

    result = topEventBannerData.data ? { ...topEventBannerData.data } : null;
    result = result.top_event_banner.filter(topEventBanner => topEventBanner.start_date <= today && topEventBanner.end_date >= today)

  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

export async function getServerSideProps(ctx) {
  //console.log('getServerSideProps');
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { cookies } = ctx.req;
  const { LOGIN_JWT = null } = cookies;
  const { JOIN_PLATFORM = null } = cookies;
  const { pageSection, pageCategory, lang = 'ko' } = ctx.query;

  let metaTagData;
  let passData;
  let topEventBannerData;

  try {
    metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함)
    passData = await getPassData();
    topEventBannerData = await getTopEventBanner();
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      loginJwt: LOGIN_JWT,
      platform: JOIN_PLATFORM,
      passData: passData,
      topEventBannerData: topEventBannerData,
      metaTagData,
      lang
    }
  };
}

export default Pass;